import { BARS_BY_LINE, ROMAN_DEGREES } from '../../util/constants'
import { getChordProperties, getScaleChords } from '../../util/TonalUtils'
import { addTts, areRangesEqual, compareTts, deepCopy, forEachRanges, getEndTt, getId, getLineFromTt, getNextRoundTt, getPrevRoundTt, getRange, getTotalTtDuration, getTtRangesIntersectInclude, isIndexInRanges, negativMod, sortChords, sortChordSelectedRanges, sortCursorRanges, substractTts, ttsRangeIsInBetween, ttsRangeIsInBetweenInclude, ttsRangesArrayCollide, ttsRangesCollide, ttsRangesCollideInclude, ttTo16th } from '../../util/utils'
import { EditorActions, EditorActionType } from './backingTrackGeneratorEditorActions'
import { Chord, ChordNoTt, EditorState, Section } from './backingTrackGeneratorEditorState'


const getPrevChordSelectedRanges = (chordSelectedRanges: number[][]): [number, number][] => {
	// @ts-ignore
	return chordSelectedRanges.map((range: number[]) => range[0] === 0 && range[1] === 0 ? undefined : [range[0] - 1 > 0 ? range[0] - 1 : 0, range[1] - 1])
		.filter((range: any) => range !== undefined)
}

const getNextChordSelectedRanges = (chordSelectedRanges: number[][], chordsLength: number): [number, number][] => {
	// @ts-ignore
	return chordSelectedRanges.map((range: number[]) => range[0] === chordsLength - 1 && range[1] === chordsLength - 1 ?
		undefined : [range[0] + 1, range[1] + 1 < chordsLength - 1 ? range[1] + 1 : chordsLength - 1])
		.filter((range: any) => range !== undefined)
}

const getChordsForChordSelectMovePrev = (chords: Chord[], chordSelectedRanges: number[][], subdivtt: string = '0:1') => {
	// const newSections = [...sections]
	const newChords = deepCopy(chords)

	chordSelectedRanges.forEach((range: number[]) => {

		console.log({ range })

		let offsetTt

		for (let i = range[0]; i <= range[1]; i++) {

			if (ttTo16th(newChords[i].transportTime) <= 0) {
				offsetTt = '0:0'
			}
			else {
				const currTt = newChords[i].transportTime
				const newTt = offsetTt === undefined ? getPrevRoundTt(currTt, subdivtt, subdivtt) : substractTts(currTt, offsetTt)

				console.log({ chordTt: currTt })
				
				if (offsetTt === undefined)
					offsetTt = substractTts(currTt, newTt)

				console.log({ chordTt2: newTt })

				newChords[i].transportTime = newTt

			}
		}
	})

	return newChords
}

const getChordsForChordSelectMoveNext = (chords: Chord[], chordSelectedRanges: number[][], totalTtDuration: string, subdivTt: string = '0:1'): [Chord[], Boolean] => {// TODO : born supp
	// const newSections = [...sections]
	const newChords = deepCopy(chords)

	let addTotalTtDuration = false

	chordSelectedRanges.forEach((range: number[]) => {
		let offsetTt
		
		for (let i = range[0]; i <= range[1]; i++) {

			const currTt = newChords[i].transportTime
			const newTt = offsetTt === undefined ? getNextRoundTt(currTt, subdivTt, subdivTt) : addTts(currTt, offsetTt)
			
			console.log({ chordTt: currTt })

			if (ttTo16th(addTts(newTt, newChords[i].transportTimeDuration)) > ttTo16th(totalTtDuration)) {
				// offsetTt = '0:0'
				addTotalTtDuration = true
			}
			
			if (offsetTt === undefined)
				offsetTt = substractTts(newTt, currTt)

			console.log({ chordTt2: newTt })

			newChords[i].transportTime = newTt
		}
	})

	return [newChords, addTotalTtDuration]
}

const getPrevCursorRanges = (cursorRanges: [string, string][], subdivTt: string = '0:1'): [string, string][] => {
	// @ts-ignore
	return cursorRanges
		.map((range: [string, string]): [string, string] | undefined => {
			const newTt = getPrevRoundTt(range[0], subdivTt, subdivTt)
			// console.log({ newTt })
			return ttTo16th(newTt) < 0 && cursorRanges.length > 1 ? undefined : [ttTo16th(newTt) < 0 ? range[0] : newTt, range[1]]
		})
		.filter((range: [string, string] | undefined) => range !== undefined)
}

const getNextCursorRanges = (cursorRanges: [string, string][], totalTtDuration: string, subdivTt: string = '0:1'): [string, string][] => {
	// @ts-ignore
	return cursorRanges
		.map((range: [string, string]): [string, string] | undefined => {
			const newTt = getNextRoundTt(range[0], subdivTt, subdivTt)
			// console.log({ newTt })
			return compareTts(newTt, totalTtDuration) === -1 && cursorRanges.length > 1 ? undefined : [compareTts(newTt, totalTtDuration) === -1 ? range[0] : newTt, range[1]]
		})
		.filter((range: [string, string] | undefined) => range !== undefined)
}


const getExpandLeftCursorRanges = (cursorRanges: [string, string][], subdivTt: string = '0:1'): [string, string][] =>
	cursorRanges.map(
		(range: [string, string]) => {
			const newTt = getPrevRoundTt(range[0], subdivTt, subdivTt)
			return [ttTo16th(newTt) >= 0 ? newTt : '0:0', ttTo16th(newTt) >= 0 ? addTts(range[1], substractTts(range[0], newTt)) : range[1]]
		})

const getExpandRightCursorRanges = (cursorRanges: [string, string][], totalTtDuration: string, subdivTt: string = '0:1'): [string, string][] =>
	cursorRanges.map(
		(range: [string, string]) => {
			const newTtDuration = substractTts(getNextRoundTt(addTts(range[0], range[1]), subdivTt, subdivTt), range[0])
			return [range[0], compareTts(addTts(range[0], newTtDuration), totalTtDuration) >= 0 ? newTtDuration : range[1]]
		})

const getCutChord = (chord: Chord, range: [string, string]): Chord => {

	// console.log({ chord, range })

	if (compareTts(range[0], chord.transportTime) >= 0) {
		const newTt = addTts(range[0], range[1])
		return {
			...chord,
			transportTime: newTt,
			transportTimeDuration: substractTts(addTts(chord.transportTime, chord.transportTimeDuration), addTts(range[0], range[1]))
		}
	}
	else if (compareTts(addTts(chord.transportTime, chord.transportTimeDuration), addTts(range[0], range[1])) >= 0) {
		return {
			...chord,
			transportTimeDuration: substractTts(range[0], chord.transportTime)
		}
	}
	else
		throw new Error('getCutChords ranges dont collide')
}


const getCut2Chords = (chord: Chord, range: [string, string]): Chord[] => [{
	...chord,
	transportTimeDuration: substractTts(range[0], chord.transportTime)
}, {
	...chord,
	id: getId(),
	transportTime: addTts(range[0], range[1]),
	transportTimeDuration: substractTts(addTts(chord.transportTime, chord.transportTimeDuration), addTts(range[0], range[1]))
}]

// Splits chords base on a range, see return type
// keep: keep chord with same range (needed cause is used for cursorRange delete && chord drag)
const getSplitChords = (range: [string, string], chord: Chord, keep: boolean = true): (Chord | undefined)[] => {

	// console.log('getSplitChords', { range, chord, inBetweenInc: ttsRangeIsInBetweenInclude(getRange(chord), range), areEqual: areRangesEqual(range, getRange(chord)), keep, inBetween: ttsRangeIsInBetween(range, getRange(chord)) })

	// si range in chordRange
	if (ttsRangeIsInBetween(range, getRange(chord)))
		return getCut2Chords(chord, range)
	// si chordRange in range
	else if (ttsRangeIsInBetweenInclude(getRange(chord), range))
		return keep && areRangesEqual(range, getRange(chord)) ? [chord] : [undefined]
	// si range X chordRange & !(chordRange in range) -> si elles se croisent
	else if (ttsRangesCollide(getRange(chord), range))
		return [getCutChord(chord, range)]
	else
		return [chord]
}

// ranges are in chronological order
// TODO : how to keep chords sorted now ? !!
	// Only call this when chordCross right ( ,..[.,-] ), and add range to chords[]
		// (need to call this with chords instead of ranges)
// FIXME : doesnt delete chord when range === chordRange, maybe not call in this case
const getSplitsChords = (ranges: [string, string][], chord: Chord): (Chord | undefined)[] => {
	console.log({ ranges, chord })
	
	const ranges2 = getTtRangesIntersectInclude(ranges, getRange(chord))

	console.log({ ranges2 })
	
	const chords: (Chord | undefined)[][] = []

	let chord2 = deepCopy(chord)

	// cut chords if needed
	if (ranges2.length > 0) {
		for (const range of ranges2) {

			console.log({ chord2 })

			if (chord2 === undefined) throw new Error('Chord2 should not be undefined')

			const newChords = getSplitChords(range, chord2, false)
			console.log({ newChords })

			if (newChords.length === 2)
				chords.push([newChords[0]])
			
			// if (newChords[newChords.length - 1] !== undefined)
				chord2 = newChords[newChords.length - 1]!// can't return undefined if called with the right params, it can ! if whole chord if cover
		}
		chords.push([chord2])
		console.log({ chords })
	} else 	{
		chords.push([chord])
	}
	
	return chords.flat()
}

// TODO : with multiSelect, try chord focus with tab, good order ? Also see if it doesnt return duplicate
const getCursorDeleteChords = (cursorRanges: [string, string][], chords: Chord[]): Chord[] => 
	sortCursorRanges(cursorRanges).flatMap((range: [string, string]) =>
		chords.flatMap((chord: Chord) => getSplitChords(range, chord))
			// @ts-ignore
			.filter((chord: Chord) => chord !== undefined))

const getCursorToChordSelectChordRanges = (cursorRanges: [string, string][], chords: Chord[]): [number, number][] => {
	const selectedChordss = cursorRanges.map((range: [string, string]) =>
		chords.filter((chord: Chord) => ttsRangeIsInBetweenInclude(getRange(chord), range)))
	
	return selectedChordss.map((selectedChords: Chord[]) =>
		selectedChords.length > 0 ? [chords.findIndex((c: Chord) => c.id === selectedChords[0].id), chords.findIndex((c: Chord) => c.id === selectedChords[selectedChords.length - 1].id)] : undefined)
		// @ts-ignore
			.filter((chord: Chord) => chord !== undefined)
}

const getChordSelectDeleteChords = (chordSelectedRanges: [number, number][], chords: Chord[]): Chord[] =>
	sortChordSelectedRanges(chordSelectedRanges).flatMap((range: [number, number]) => chords.filter((_, i: number) => !(range[0] <= i && i <= range[1])))


const getCursorExpandCursorRanges = (cursorRanges: [string, string][], tt: string, initialTt: string) => {
	const newCursorRanges = deepCopy(cursorRanges)

	if (compareTts(tt, initialTt) === 1) {
		newCursorRanges[newCursorRanges.length - 1][0] = tt
		newCursorRanges[newCursorRanges.length - 1][1] = substractTts(initialTt, tt)
	}
	else if (compareTts(tt, initialTt) === -1) {
		newCursorRanges[newCursorRanges.length - 1][0] = initialTt
		newCursorRanges[newCursorRanges.length - 1][1] = substractTts(tt, initialTt)
	}
	else {
		newCursorRanges[newCursorRanges.length - 1][0] = initialTt
		newCursorRanges[newCursorRanges.length - 1][1] = '0:0'
	}

	// console.log({ range1: cursorRanges[cursorRanges.length - 1], tt, range2: newCursorRanges[newCursorRanges.length - 1] })

	return newCursorRanges
}

// TODO : check if each time there is a range.map the range is ordered first

const getChordSelectGroupRanges = (chords: Chord[], sections: Section[], cursorRanges: [string, string][], chordSelectedRanges: [number, number][]): [number, number][] => {

	// might contains duplicate sections
	const sections2 = cursorRanges.length > 0 ? sortCursorRanges(cursorRanges)
			.flatMap((range: [string, string]) => sections.filter((section: Section) => ttsRangesCollideInclude(getRange(section), range))) :
		chordSelectedRanges.length > 0 ? sortChordSelectedRanges(chordSelectedRanges)
			.flatMap((range: [number, number]) => sections.filter((section: Section) => ttsRangesCollideInclude(getRange(section), [chords[range[0]].transportTime, substractTts(getEndTt(chords[range[1]]), chords[range[0]].transportTime)])))
		: deepCopy(sections)// if no cursorRanges & no chordRanges then take all the sections

	const sectionsRange: [string, string] = [sections2[0].transportTime, substractTts(getEndTt(sections2[sections2.length - 1]), sections2[0].transportTime)]
	
	const chords2 = chords.filter((chord: Chord) => ttsRangesCollide(getRange(chord), sectionsRange))

	return chords2.length > 0 ? [[chords.findIndex((c: Chord) => c.id === chords2[0].id), chords.findIndex((c: Chord) => c.id === chords2[chords2.length - 1].id)]] : []
}

// const getSplitChordsWithRanges = (ranges: [string, string][], chord: Chord) => {
// 	let set = new Set()

// 	for (let i = 0; i < ranges.length; i++) {
// 		const cutChords = getSplitChords(ranges[i], chord)
// 			// @ts-ignore
// 			.filter((c: Chord) => c !== undefined)
// 		// @ts-ignore
// 		set = new Set([...set, ...cutChords])
// 	}

// 	return Array.from(set)
// }

// TOTEST : j'ai un doute si cela fonctionne avec le splitChords puisque celui ci retourne un nouvel id
const getNewChordIndex = (chords: Chord[], chordIndex: number, sortedChords: Chord[]) =>
	sortedChords.findIndex((c: Chord) => c.id === chords[chordIndex].id)

const getNewChordRanges = (chords: Chord[], ranges: [number, number][], sortedChords: Chord[]) => {
	const newRanges: [number, number][] = []

	let prevIndex

	for (const range of ranges) {
		let newStart = getNewChordIndex(chords, range[0], sortedChords)
		let newIndex: number
		for (let i = range[0]; i <= range[1]; i++) {
			newIndex = getNewChordIndex(chords, i, sortedChords)
			if (prevIndex !== undefined && newIndex - prevIndex > 1) {
				newRanges.push([newStart, prevIndex])
				newStart = newIndex
			}
			prevIndex = newIndex
		}
		newRanges.push([newStart, newIndex!])
	}

	console.log({ ranges, newRanges, chords, sortedChords })

	return newRanges
}
	
// MAYBE : Could merge contiguous newRanges
const getChordSelectDragFakeChords = (chords: Chord[], chordIndex: number, chordSelectedRanges: [number, number][], transportTime: string, totalTtDuration: string, fakeChords: Chord[], dragEnd: boolean = false): [Chord[], [number, number][] | undefined, boolean] => {
	let chords2 = deepCopy(chords)
	const chordSelectedRanges2 = getNewChordRanges(fakeChords, chordSelectedRanges, chords2)

	console.log({ chordSelectedRanges2 })

	const ttDiff = substractTts(transportTime, chords2[chordIndex].transportTime)

	let addTotalTtDuration = false

	const chordsDrag: Chord[] = []

	// update chords tts
	for (let i = 0; i < chordSelectedRanges2.length; i++) {
		const range = chordSelectedRanges2[i]
		for (let i = range[0]; i <= range[1]; i++) {
			const newTt = addTts(chords2[i].transportTime, ttDiff)
			if (ttTo16th(newTt) < 0) {
				// return [deepCopy(fakeChords || chords), chordSelectedRanges2, false]
				return [deepCopy(fakeChords), chordSelectedRanges2, false]
			}
			else if (compareTts(addTts(newTt, chords2[i].transportTimeDuration), totalTtDuration) === -1) {
				addTotalTtDuration = true
			}
			else {
				chords2[i].transportTime = newTt
			}
			chordsDrag.push(chords2[i])
		}
	}

	let newChordSelectedRanges
	let sortedChords2

	const ranges = chordsDrag.map(getRange)
	
	chords2 = chords2.flatMap((chord: Chord, i: number) => {
		// opti keep an updated version of ranges (cause chronological)
		// return i !== chordIndex ? getSplitsChords(ranges, chord) : chord
		return !isIndexInRanges(i, chordSelectedRanges2) ? getSplitsChords(ranges, chord) : chord
	})
	// @ts-ignore
	.filter((chord: Chord) => chord !== undefined)

	// if (dragEnd) {
		// cut chords
		// TODO : refactor this (about dragEnd)
	
	sortedChords2 = sortChords(chords2)
	newChordSelectedRanges = getNewChordRanges(chords, chordSelectedRanges2, sortedChords2)
	console.log({ newChordSelectedRanges })
		
	// }
	// return [chords2, chordSelectedRanges2, addTotalTtDuration]
	return [sortedChords2 || chords2, newChordSelectedRanges || chordSelectedRanges2, addTotalTtDuration]
}// DONE : maybe keep chord that are not visible, since it will change indexes, what about chord that are split in two ?

const getChordSelectDragStartChordSelectRanges = (chordIndex: number, chordSelectedRanges: [number, number][]): [number, number][] => {
	if (chordSelectedRanges.find((range: [number, number]) => range[0] <= chordIndex && chordIndex <= range[1])) {
		return deepCopy(chordSelectedRanges)
	}
	else {
		return [[chordIndex, chordIndex]]
	}
}


const getSectionsAddTotalTtDuration = (sections: Section[]) => {
	const newSections = deepCopy(sections)
	newSections[newSections.length - 1].transportTimeDuration = addTts(newSections[newSections.length - 1].transportTimeDuration, BARS_BY_LINE + ':0')
	return newSections
}

// TOTEST : Can there be rerender issue on dragStart ? -> if this is the case use lineIndex
const getChordSelectDragStartDragLineIndexes = (chords: Chord[], ranges: [number, number][], lineIndex: number) => {
	const dragLineIndexes: number[] = []
	
	forEachRanges(sortChordSelectedRanges(ranges), (i: number) => {
		const chord = chords[i]
		const chordLineIndex = getLineFromTt(chord.transportTime)// This might need to return 2 lines if chord cross line !
		// dragLineIndexes.push(chordLineIndex - lineIndex)
		dragLineIndexes.push(chordLineIndex)
	})

	return dragLineIndexes
}

const getChordSelectDragDragLineIndexes = (dragLineIndexes: number[], lineDiff: number) =>
	dragLineIndexes.map((index: number) => index + lineDiff)

// TOOPTI: could be optimize by not doing the whole chords comparision for each chords
// one filter for chordsToCut && chords2
// might get opti by looking at the requirements (if chord split in 2, then it will be the only one)
// range is [start, end]
const rearrangeChords = (chords: Chord[], range: [number, number]) => {

	// console.log({ chords, range })

	const ttRanges: [string, string][] = []
	for (let i = range[0]; i <= range[1]; i++) {
		ttRanges.push(getRange(chords[i]))
	}

	const chordsToCut = chords.filter((c: Chord, i: number) =>
		ttsRangesArrayCollide(getRange(c), ttRanges) && !(range[0] <= i && i <= range[1]))
	let chords2 = chords.filter((c: Chord, i: number) => !ttsRangesArrayCollide(getRange(c), ttRanges) || (range[0] <= i && i <= range[1]))

	for (let i = 0; i < chordsToCut.length; i++) {
		// @ts-ignore
		const cutChords = getSplitsChords(ttRanges, chordsToCut[i]).filter((c: Chord) => c != undefined)
		// @ts-ignore
		chords2 = [...chords2, ...cutChords]
	}

	return chords2
}

// called with ranges duration = '0:0'
const getChordAddChords = (chords: Chord[], chord: ChordNoTt, cursorRanges: [string, string][], ttD: string) => {
	let chords2 = deepCopy(chords)
	
	for (const range of cursorRanges) {
		const chord2 = {
			...chord,
			transportTime: range[0],
			transportTimeDuration: ttTo16th(range[1]) > 0 ? range[1] : ttD,
			id: getId(),
		}
		chords2.push(chord2)
	}


	chords2 = rearrangeChords(chords2, [chords2.length - 1, chords2.length - 1])

	chords2 = sortChords(chords2)

	return chords2
}

const getChordAddCursorRanges = (ranges: [string, string][], ttD: string, totalTtDuration: string): [[string, string][], boolean] => {
	let addTotalTtDuration = false

	return [ranges.map((range: [string, string]) => {
		const newTt = addTts(range[0], ttTo16th(range[1]) !== 0 ? range[1] : ttD)

		if (compareTts(newTt, totalTtDuration) === -1)
			addTotalTtDuration = true

		return [newTt, range[1]]
	}), addTotalTtDuration]
}

// TOOPTI : might not need to recompute degreesChords each time
// TODO : 2nd params for getScaleChords, to set the curr chord type ( -> save chordConfig in chord (data might already being here) )
const getChordDegreeUpDownChord = (scale: string, chord: Chord, up: boolean) => {
	if (!chord.degreeName) return chord
	
	const degreesChords = getScaleChords(scale, getChordProperties(chord))
	
	const currDegree = chord.degreeName.split(' ')[0].toUpperCase()
	const degreeIndex = ROMAN_DEGREES.findIndex((d: string) => d === currDegree)

	return {
		...chord,
		...degreesChords[negativMod(degreeIndex + (up ? 1 : -1), degreesChords.length)]
	}
}

// Could only take one chordRange (only work with one and only one contiguous chord range)
const getProgressionAddChords = (chords: Chord[], newChords: ChordNoTt[], chordRanges: [number, number][], ttD: string, totalTtDuration: string): [Chord[], [number, number][], boolean] => {
	let chords2 = deepCopy(chords)
	
	let addTotalTtDuration = false

	for (const range of chordRanges) {

		let lastChord: Chord

		for (let i = 0; i < newChords.length; i++) {
			if (range[0] + i <= range[1]) {
				const chord2 = {
					...chords2[i + range[0]],
					...newChords[i],
				}

				chords2[i + range[0]] = chord2
				lastChord = chord2
			}
			else {
				const chord2 = {
					...newChords[i],
					transportTime: addTts(lastChord!.transportTime, lastChord!.transportTimeDuration),
					transportTimeDuration: ttD,
					id: getId(),
				}

				if (compareTts(addTts(chord2.transportTime, chord2.transportTimeDuration), totalTtDuration) === -1)
					addTotalTtDuration = true

				chords2.push(chord2)
				lastChord = chord2
			}
		}
	}


	chords2 = rearrangeChords(chords2, [(chords2.length - 1) - (newChords.length - (chordRanges[0][1] - chordRanges[0][0])), chords2.length - 1])

	chords2 = sortChords(chords2)

	return [chords2, chordRanges.map((range: [number, number]) => [range[0], newChords.length - (range[1] - range[0])]), addTotalTtDuration]
}



const backingTrackGeneratorEditorReducer = (editor: EditorState, action: EditorActions): EditorState => {

	// @ts-ignore
	console.log({ actionType: EditorActionType[action.type], payload: action.payload, editor })
	// @ts-ignore
	console.log({ lineIndex: action?.payload?.lineIndex })

	let newSections = undefined
	let newChords = undefined
	let chordRanges = undefined
	let newChordSelectedRanges = undefined
	let newFakeChords = undefined
	let newCurrChordsSelectDragLineIndexes = undefined
	let newCursorRanges = undefined

	switch (action.type) {

			// Play/Stop

			case EditorActionType.Play:
				return {
					...editor,
					state: {
						...editor.state,
						isPlaying: true,
						playTransportTime: '0',
					}
				}
			case EditorActionType.Progress:
				return {
					...editor,
					state: {
						...editor.state,
						playTransportTime: action.payload.transportTime,
					}
				}
			case EditorActionType.Complete:
				return {
					...editor,
					state: {
						...editor.state,
						isPlaying: false,
						playTransportTime: undefined,
					}
				}
			case EditorActionType.Stop:
				return {
					...editor,
					state: {
						...editor.state,
						isPlaying: false,
						playTransportTime: undefined,
					}
				}

			// Cursor Move

			case EditorActionType.CursorMovePrevBar:
				return {
					...editor,
					state: {
						...editor.state,
						cursorRanges: getPrevCursorRanges(editor.state.cursorRanges, '1:0')
					}
				}
			case EditorActionType.CursorMoveNextBar:
				return {
					...editor,
					state: {
						...editor.state,
						cursorRanges: getNextCursorRanges(editor.state.cursorRanges, getTotalTtDuration(editor.sections), '1:0')
					}
				}

			case EditorActionType.CursorMovePrevBeat:
				return {
					...editor,
					state: {
						...editor.state,
						cursorRanges: getPrevCursorRanges(editor.state.cursorRanges)
					}
				}
			case EditorActionType.CursorMoveNextBeat:
				return {
					...editor,
					state: {
						...editor.state,
						cursorRanges: getNextCursorRanges(editor.state.cursorRanges, getTotalTtDuration(editor.sections))
					}
				}

			case EditorActionType.CursorMovePrev16th:
				return {
					...editor,
					state: {
						...editor.state,
						cursorRanges: getPrevCursorRanges(editor.state.cursorRanges, '0:0:1')
					}
				}
			case EditorActionType.CursorMoveNext16th:
				return {
					...editor,
					state: {
						...editor.state,
						cursorRanges: getNextCursorRanges(editor.state.cursorRanges, getTotalTtDuration(editor.sections), '0:0:1')
					}
				}

			// Cursor Expand

			case EditorActionType.CursorExpandLeftBar:
				return {
					...editor,
					state: {
						...editor.state,
						cursorRanges: getExpandLeftCursorRanges(editor.state.cursorRanges, '1:0'),
					}
				}
			case EditorActionType.CursorExpandRightBar:
				return {
					...editor,
					state: {
						...editor.state,
						cursorRanges: getExpandRightCursorRanges(editor.state.cursorRanges, getTotalTtDuration(editor.sections), '1:0'),
					}
				}

			case EditorActionType.CursorExpandLeftBeat:
				return {
					...editor,
					state: {
						...editor.state,
						cursorRanges: getExpandLeftCursorRanges(editor.state.cursorRanges, '0:1'),
					}
				}
			case EditorActionType.CursorExpandRightBeat:
				return {
					...editor,
					state: {
						...editor.state,
						cursorRanges: getExpandRightCursorRanges(editor.state.cursorRanges, getTotalTtDuration(editor.sections), '0:1'),
					}
				}

			case EditorActionType.CursorExpandLeft16th:
				return {
					...editor,
					state: {
						...editor.state,
						cursorRanges: getExpandLeftCursorRanges(editor.state.cursorRanges, '0:0:1'),
					}
				}
			case EditorActionType.CursorExpandRight16th:
				return {
					...editor,
					state: {
						...editor.state,
						cursorRanges: getExpandRightCursorRanges(editor.state.cursorRanges, getTotalTtDuration(editor.sections), '0:0:1'),
					}
				}

			// Cursor Others

			case EditorActionType.CursorUnselect:
				return {
					...editor,
					state: {
						...editor.state,
						cursorRanges: [[editor.state.cursorRanges[0][0], '0:0']],
					}
				}
			
			case EditorActionType.CursorDelete:
				newChords = getCursorDeleteChords(editor.state.cursorRanges, editor.chords)

				return {
					...editor,
					chords: newChords,
					state: {
						...editor.state,
						cursorRanges: [[editor.state.cursorRanges[0][0], '0:0']],
					}
				}
			
			case EditorActionType.CursorToChordSelect:
				newChordSelectedRanges = getCursorToChordSelectChordRanges(editor.state.cursorRanges, editor.chords)

				return {
					...editor,
					state: {
						...editor.state,
						chordSelectedRanges: newChordSelectedRanges,
						cursorRanges: newChordSelectedRanges.length > 0 ? [] : editor.state.cursorRanges,
					}
				}
			
			case EditorActionType.CursorMove:
				return {
					...editor,
					state: {
						...editor.state,
						chordSelectedRanges: [],
						cursorRanges: [[action.payload.transportTime, '0:0']],
					}
				}
			
			case EditorActionType.CursorDragStart:
				return {
					...editor,
					state: {
						...editor.state,
						chordSelectedRanges: [],
						cursorRanges: [[action.payload.transportTime, '0:0']],
						initialCursorDragTt: action.payload.transportTime,
					}
				}
			case EditorActionType.CursorDrag:
				return {
					...editor,
					state: {
						...editor.state,
						cursorRanges: getCursorExpandCursorRanges(editor.state.cursorRanges, action.payload.transportTime, editor.state.initialCursorDragTt!),
					}
				}
			case EditorActionType.CursorDragEnd:
				return {
					...editor,
					state: {
						...editor.state,
						initialCursorDragTt: undefined,
					}
				}
			
			// Chord Drag

			case EditorActionType.ChordSelectDragStart:
				newChordSelectedRanges = getChordSelectDragStartChordSelectRanges(action.payload.chordIndex, editor.state.chordSelectedRanges)
				newCurrChordsSelectDragLineIndexes = getChordSelectDragStartDragLineIndexes(editor.chords, newChordSelectedRanges, action.payload.globalLineIndex)
			
				return {
					...editor,
					fakeChords: deepCopy(editor.chords),
					state: {
						...editor.state,
						cursorRanges: [],
						chordSelectedRanges: newChordSelectedRanges,
						currChordSelectDragTt: action.payload.transportTime,
						currChordDragIndex: action.payload.chordIndex,
						
						currChordSelectDragLineIndex: action.payload.globalLineIndex,
						currChordsSelectDragLineIndexes: newCurrChordsSelectDragLineIndexes,
					}
				}
			case EditorActionType.ChordSelectDrag:
				const [newFakeChords0, newChordSelectedRanges0, addTotalTtDuration3] = getChordSelectDragFakeChords(editor.chords, editor.state.currChordDragIndex!,
					editor.state.chordSelectedRanges, action.payload.transportTime, getTotalTtDuration(editor.sections), editor.fakeChords!)

				newCurrChordsSelectDragLineIndexes = action.payload.globalLineIndex !== editor.state.currChordSelectDragLineIndex ? getChordSelectDragDragLineIndexes(editor.state.currChordsSelectDragLineIndexes!, action.payload.globalLineIndex - editor.state.currChordSelectDragLineIndex!) : deepCopy(editor.state.currChordsSelectDragLineIndexes)
				
				if (addTotalTtDuration3) {
					newSections = getSectionsAddTotalTtDuration(editor.sections)
				}

				return {
					...editor,
					fakeChords: newFakeChords0,
					sections: newSections || editor.sections,
					state: {
						...editor.state,
						chordSelectedRanges: newChordSelectedRanges0!,
						currChordSelectDragTt: action.payload.transportTime,
						currChordSelectDragLineIndex: action.payload.globalLineIndex,
						currChordsSelectDragLineIndexes: newCurrChordsSelectDragLineIndexes,
					}
				}
			// case EditorActionType.ChordSelectDragChangeLine:// TODO : test if this handle when changing line and x in diagonal -> it's not
			// 	const transportTime = getTtFromLineIndexAndTt(action.payload.lineIndex, editor.chords[editor.state.chordSelectedRanges[0][0]].transportTime)
			// 	// console.log({ actChordSelectDragChangeLine: transportTime })
			// 	newFakeChords = getChordSelectDragFakeChords(editor.chords, editor.state.chordSelectedRanges[0][0], transportTime)

			// 	return {
			// 		...editor,
			// 		fakeChords: newFakeChords,
			// 		state: {
			// 			...editor.state,
			// 			currChordSelectDragTt: transportTime,
			// 			currChordSelectDragLineIndex: action.payload.lineIndex,
			// 		}
			// 	}
			case EditorActionType.ChordSelectDragEnd:
				const [newFakeChords1, newChordSelectedRanges1, addTotalTtDuration4] = getChordSelectDragFakeChords(editor.chords, editor.state.currChordDragIndex!,
					editor.state.chordSelectedRanges, action.payload.transportTime, getTotalTtDuration(editor.sections), editor.fakeChords!, true)
				
				if (addTotalTtDuration4) {
					newSections = getSectionsAddTotalTtDuration(editor.sections)
				}

				return {
					...editor,
					chords: newFakeChords1,
					fakeChords: undefined,
					sections: newSections || editor.sections,
					state: {
						...editor.state,
						chordSelectedRanges: newChordSelectedRanges1!,
						currChordSelectDragTt: undefined,
						currChordDragIndex: undefined,
						currChordSelectDragLineIndex: undefined,
						currChordsSelectDragLineIndexes: undefined,
					}
				}
		
			// Chord Selection

			case EditorActionType.ChordSelect:
				return {
					...editor,
					state: {
						...editor.state,
						chordSelectedRanges: [[action.payload.index, action.payload.index]],
						cursorRanges: []
					}
				}
			case EditorActionType.ChordUnselect:
				if (editor.state.chordSelectedRanges.length === 0)// TODO : investigate, fire twice when dragging out from a selected chord
					return {
						...editor
					}

				return {
					...editor,
					state: {
						...editor.state,
						chordSelectedRanges: [],
						cursorRanges: [[editor.chords[editor.state.chordSelectedRanges[0][0]].transportTime, '0:0']]
					}
				}
			case EditorActionType.ChordSelectPrev:
				return {
					...editor,
					state: {
						...editor.state,
						chordSelectedRanges: getPrevChordSelectedRanges(editor.state.chordSelectedRanges)
					}
				}
			case EditorActionType.ChordSelectNext:
				return {
					...editor,
					state: {
						...editor.state,
						chordSelectedRanges: getNextChordSelectedRanges(editor.state.chordSelectedRanges, editor.chords.length)
					}
				}
			case EditorActionType.ChordSelectExpandLeft:
				return {
					...editor,
					state: {
						...editor.state,
						chordSelectedRanges: editor.state.chordSelectedRanges.map((range: [number, number]) => [range[0] - 1 >= 0 ? range[0] - 1 : 0, range[1]])
					}
				}
			case EditorActionType.ChordSelectExpandRight:
				return {
					...editor,
					state: {
						...editor.state,
						chordSelectedRanges: editor.state.chordSelectedRanges.map((range: [number, number]) => [range[0], range[1] + 1 < editor.chords.length ? range[1] + 1 : editor.chords.length - 1])
					}
				}

			// Chord Move

			case EditorActionType.ChordSelectMovePrevBar:
				newChords = getChordsForChordSelectMovePrev(editor.chords, editor.state.chordSelectedRanges, '1:0')

				// console.log({ chords: deepCopy(editor.chords), newChords: deepCopy(newChords) })

				return {
					...editor,
					chords: newChords,
				}

			case EditorActionType.ChordSelectMoveNextBar:
				const [chords0, addTotalTtDuration0] = getChordsForChordSelectMoveNext(editor.chords, editor.state.chordSelectedRanges, getTotalTtDuration(editor.sections), '1:0')

				newSections = deepCopy(editor.sections)

				if (addTotalTtDuration0) {
					newSections = getSectionsAddTotalTtDuration(newSections)
				}

				return {
					...editor,
					sections: newSections,
					chords: chords0,
				}

			case EditorActionType.ChordSelectMovePrevBeat:
				newChords = getChordsForChordSelectMovePrev(editor.chords, editor.state.chordSelectedRanges)

				return {
					...editor,
					chords: newChords,
				}

			case EditorActionType.ChordSelectMoveNextBeat:
				const [chords1, addTotalTtDuration1] = getChordsForChordSelectMoveNext(editor.chords, editor.state.chordSelectedRanges, getTotalTtDuration(editor.sections))

				newSections = deepCopy(editor.sections)

				if (addTotalTtDuration1) {
					newSections = getSectionsAddTotalTtDuration(newSections)
				}

				return {
					...editor,
					sections: newSections,
					chords: chords1,
				}
			
			case EditorActionType.ChordSelectMovePrev16th:
				newChords = getChordsForChordSelectMovePrev(editor.chords, editor.state.chordSelectedRanges, '0:0:1')

				return {
					...editor,
					chords: newChords,
				}

			case EditorActionType.ChordSelectMoveNext16th:
				const [chords2, addTotalTtDuration2] = getChordsForChordSelectMoveNext(editor.chords, editor.state.chordSelectedRanges, getTotalTtDuration(editor.sections), '0:0:1')

				newSections = deepCopy(editor.sections)

				if (addTotalTtDuration2) {
					newSections = getSectionsAddTotalTtDuration(newSections)
				}

				return {
					...editor,
					sections: newSections,
					chords: chords2,
				}

				case EditorActionType.ChordSelectDelete:
					newChords = getChordSelectDeleteChords(editor.state.chordSelectedRanges, editor.chords)
	
					return {
						...editor,
						chords: newChords,
						state: {
							...editor.state,
							chordSelectedRanges: [],
							cursorRanges: [[editor.chords[editor.state.chordSelectedRanges[0][0]].transportTime, '0:0']],
						}
					}

				case EditorActionType.ChordSelectGroup:
					const currTime = Date.now()// TODO : find better solution to detect select all
					
					return {
						...editor,
						state: {
							...editor.state,
							chordSelectedRanges: editor.state.lastTimeSelectGroup && currTime - 800 < editor.state.lastTimeSelectGroup ? [[0, editor.chords.length - 1]] :
								getChordSelectGroupRanges(editor.chords, editor.sections, editor.state.cursorRanges, editor.state.chordSelectedRanges),
							cursorRanges: [],
							lastTimeSelectGroup: currTime,
						}
					}
	
			// Chord Other
				
			case EditorActionType.Import:
				return {
					...editor,
					sections: action.payload.sections
				}

			case EditorActionType.Import:
				return {
					...editor,
					sections: action.payload.sections
				}
			case EditorActionType.ChordChange:// Warning : this merge prevChord with newChord
				newChords = deepCopy(editor.chords)
		
				// console.log({ handleChange: chord })
				// TODO : Fix wrong onChange/update after importing
		
				for (const range of editor.state.chordSelectedRanges) {
					for (let i = range[0]; i <= range[1]; i++) {
						newChords[i] = {
							...newChords[i],
							...action.payload.chord
						}
					}
				}

				return {
					...editor,
					chords: newChords
				}
				
			case EditorActionType.ChordTabPressed:
				return {
					...editor,
					state: {
						...editor.state,
						chordEditIndex: action.payload.index + 1,
						chordSelectedRanges: [[action.payload.index + 1, action.payload.index + 1]]
					}
				}
			case EditorActionType.ChordBlur:
				return {
					...editor,
					state: {
						...editor.state,
						chordEditIndex: undefined,
					}
				}
			case EditorActionType.ChordFocus:
				return {
					...editor,
					state: {
						...editor.state,
						chordEditIndex: action.payload.index,
					}
			}
		
			case EditorActionType.ChordAdd:// DONE : extend total ttD if needed (see for an abstraction of this since it seems to appear quite often)
				// requires a cursorTt to be set, so no chordRanges to update
				newChords = getChordAddChords(editor.chords, action.payload.chord, editor.state.cursorRanges, editor.state.currAddChordTtD)
				const [newCursorRanges0, addTotalTtDuration5] = getChordAddCursorRanges(editor.state.cursorRanges, editor.state.currAddChordTtD, getTotalTtDuration(editor.sections))
			
				newSections = deepCopy(editor.sections)

				if (addTotalTtDuration5) {
					newSections = getSectionsAddTotalTtDuration(newSections)
				}
			
				return {
					...editor,
					chords: newChords,
					state: {
						...editor.state,
						cursorRanges: newCursorRanges0,
					}
			}
		
			case EditorActionType.ChordDegreeUp:
				newChords = deepCopy(editor.chords)
		
				for (const range of editor.state.chordSelectedRanges) {
					for (let i = range[0]; i <= range[1]; i++) {
						newChords[i] = getChordDegreeUpDownChord(editor.config.scale, newChords[i], true)
					}
				}

				return {
					...editor,
					chords: newChords
				}
			case EditorActionType.ChordDegreeDown:
				newChords = deepCopy(editor.chords)
		
				for (const range of editor.state.chordSelectedRanges) {
					for (let i = range[0]; i <= range[1]; i++) {
						newChords[i] = getChordDegreeUpDownChord(editor.config.scale, newChords[i], false)
					}
				}

				return {
					...editor,
					chords: newChords
				}

			// Controls 
		
			case EditorActionType.CurrAddChordTtdChange:
				return {
					...editor,
					state: {
						...editor.state,
						currAddChordTtD: action.payload.ttD,
					}
				}
		
			// Suggestions

			case EditorActionType.ProgressionAdd:
				const [newChords0, newChordSelectedRanges2, addTotalTtDuration6] = getProgressionAddChords(editor.chords, action.payload.chords, editor.state.chordSelectedRanges, editor.state.currAddChordTtD, getTotalTtDuration(editor.sections))
				
				newSections = deepCopy(editor.sections)

				if (addTotalTtDuration6) {
					newSections = getSectionsAddTotalTtDuration(newSections)
				}
			
				return {
					...editor,
					chords: newChords0,
					state: {
						...editor.state,
						chordSelectedRanges: newChordSelectedRanges2,
					}
			}
		
			default:
				return editor
	}
}

export default backingTrackGeneratorEditorReducer

// TODO : move chords right doesnt well compute transportTimes
